import { EyeIcon as PhosphorEyeIcon } from "@phosphor-icons/react/dist/ssr/Eye";

import { createAppIcon } from "@/components/createAppIcon";

export const VisibleIcon = /* @__PURE__ */ createAppIcon(PhosphorEyeIcon);
